(function () {
	
	const productInfo = () => {
		const swiperWrap = document.querySelector('.related-product__swiper');
        const matchMedia = window.matchMedia('(max-width: 750px)');

		let swiper
        
        const swiperEvent = (boolean) => {
            if (boolean) {
                if(swiper) {
                    swiper.destroy(true, true);
                    swiper = null;
                }
            } else {
                swiper = new Swiper(swiperWrap, {
                    slidesPerView : 3,
                    spaceBetween: 16,
                    navigation: {
                        prevEl: '.related-product__left',
                        nextEl: '.related-product__right',
                    },
                })
            }
        };

        if (swiperWrap) {
            swiperEvent(matchMedia.matches);
            matchMedia.addEventListener('change', e => swiperEvent(e.matches));
        }

	}

	document.addEventListener('shopify:section:load', productInfo);
	productInfo();

})();